import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import WindowUtil from './WindowUtil';

export default class AboutPage {

   static getInstance() {
      if (!AboutPage.instance) {
         AboutPage.instance = new AboutPage();
      }
      return AboutPage.instance;
   }

   constructor() {
      this.windowUtil = WindowUtil.getInstance();
      this.initGsap();
      AboutPage.instance = this;  // インスタンスを保存
   }

   initGsap() {
      gsap.registerPlugin(ScrollTrigger);

      // bg-garaのパララックス効果
      document.querySelectorAll("[data-anim-parallax-wrap]").forEach((el) => {
         const elParallax = el.querySelector("[data-anim-parallax]");
         // 初期位置を下にズラす
         gsap.set(elParallax, { yPercent: 30 });  // 初期位置を下方向に30%移動
         gsap.to(elParallax, {
            yPercent: -30,
            ease: "none",
            scrollTrigger: {
               trigger: el,
               start: "top bottom",
               end: "bottom top",
               scrub: true,
               // markers: true, // デバッグ用
            }
         });
      });
   }

   // NOTE: ScrollTrigger.matchMedia({ は非推奨
   handleMediaQueries() {
      if (this.windowUtil.matchMediaQueryXsmall.matches) {
         // Xsmall screen size detected
         console.log("Xsmall screen size detected");
         // Xsmallサイズ用の処理をここに記述
      } else if (this.windowUtil.matchMediaQuerySmall.matches) {
         // Small screen size detected
         console.log("Small screen size detected");
         // Smallサイズ用の処理をここに記述
      } else if (this.windowUtil.matchMediaQueryMedium.matches) {
         // Medium screen size detected
         console.log("Medium screen size detected");
         // Mediumサイズ用の処理をここに記述
      }
      // 他のサイズも追加可能
   }
};
